import yenpin1 from "./imgs/yenpin1.png";
import yenpin2 from "./imgs/yenpin2.png";
import yenpin3 from "./imgs/yenpin3.png";
import yenpin4 from "./imgs/yenpin4.png";
import yenpin5 from "./imgs/yenpin5.png";
import yenpin6 from "./imgs/yenpin6.png";
import yenpin7 from "./imgs/yenpin7.png";
import yenpin8 from "./imgs/yenpin8.png";
import yenpin9 from "./imgs/yenpin9.png";

const YenpinImg: string[] = [
  yenpin1,
  yenpin2,
  yenpin3,
  yenpin4,
  yenpin5,
  yenpin6,
  yenpin7,
  yenpin8,
  yenpin9,
];

export default YenpinImg;
